// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";

// App
import { PaymentDTO } from "../../DTO/PaymentDTO";

export class PaymentModel extends ModelBase<PaymentModel, PaymentDTO> {
    @MobX.observable public id: string | null = null;

    @MobX.action
    public fromDto = (model: PaymentDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
        }
    };

    @MobX.action
    public toDto = (): PaymentDTO => {
        let model: PaymentDTO = {
            id: this.id,
        };

        return model;
    };
}
